import { datadogRum } from '@datadog/browser-rum';
import { StorageHelper } from '@smg-real-estate/hg-search-libs';
import axios from 'axios';

import { getAuthToken } from '@/helpers/Authentication/authClient';
import { HgLocalStorageKey } from '@/models/HgLocalStorageKey';

import { StorageNamespace } from '../storage-namespaces';

const TTL_CHECK_INTERVAL = 900; //set expiry time to 15 minutes

export interface TenantPlusSubscriptionCacheData {
  subscriptionState: string;
  createdAt: string;
  startDate: string;
  expiredAt: string;
}

export const checkTenantPlusSubscriber = async (): Promise<boolean> => {
  const tenantPlusStorageHelper = new StorageHelper(StorageNamespace.tenantPlus);
  const tenantPlusSubscriptionCached = tenantPlusStorageHelper.getLocalStorageExpirableItem(
    HgLocalStorageKey.TENANT_PLUS_SUPSCRIPTION_CACHE,
  );

  if (!tenantPlusSubscriptionCached?.subscriptionState) {
    const tenantPlusSubscription = await getTenantPlusSubscription();

    if (!tenantPlusSubscription) {
      return false;
    }

    tenantPlusStorageHelper.setLocalStorageExpirableItem(
      HgLocalStorageKey.TENANT_PLUS_SUPSCRIPTION_CACHE,
      tenantPlusSubscription,
      TTL_CHECK_INTERVAL,
    );

    return true;
  }

  return tenantPlusSubscriptionCached?.subscriptionState === 'created';
};

export const getTenantPlusSubscription = async (): Promise<
  undefined | TenantPlusSubscriptionCacheData
> => {
  const authToken = await getAuthToken();

  if (!authToken) {
    return undefined;
  }

  try {
    const { data } = await axios.get(
      `${import.meta.env.VUE_TENANT_PLUS_API_ENDPOINT}/authentication`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );

    return data;
  } catch (ex) {
    if (ex.response?.status !== 401 && ex.response?.status !== 403) {
      datadogRum.addError(ex, {
        message: 'Failed to authenticate TenantPlus user',
      });
    }

    return undefined;
  }
};
